import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.869 5.41178L15.0882 1.63053C14.6405 1.18289 13.9152 1.18289 13.4676 1.63053C13.0199 2.07817 13.0199 2.80348 13.4676 3.25112L17.2484 7.03237C17.6961 7.48001 18.4214 7.48001 18.869 7.03237C19.3167 6.58473 19.3167 5.85942 18.869 5.41178Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.94434 9.77429H14.5065",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.5781 18.9219C0.533863 17.8777 0.533863 16.1849 1.5781 15.141L13.4676 3.2511L17.2485 7.03197L5.35935 18.9219C4.31511 19.9661 2.62233 19.9661 1.57848 18.9219H1.5781Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.67934 1.29517L5.2499 3.80836C6.02105 5.04204 5.13417 6.64239 3.67934 6.64239C2.22452 6.64239 1.33764 5.04204 2.10879 3.80836L3.67934 1.29517Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }